import * as React from 'react'
import {compose} from 'redux'
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { getCotation, getCotationHistory } from 'src/core/redux/action/cotationAction'
import { omit } from 'lodash'
import { ICotation } from 'src/type/cotation'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/shared/Toast/Toast'

const CotationCtx = React.createContext({});

export const withCotation = (Component: any) => (props: any) => (
    <CotationCtx.Consumer>
      {(other: CtxCotation) => <Component {...props} {...other}/>}
    </CotationCtx.Consumer>
);

export interface CtxCotation{
    detail: ICotation | undefined;
    paramsHistory: any;
    formParams: any;
    productType: string;
    refesh: () => void
}

interface IProps extends 
    WithToast,
    WithGlobalProgress,
    RouteComponentProps<any>,
    ReturnType<typeof dispatch2props> {
    status: string;
}
interface IStates extends CtxCotation{
}

class CotationProvider extends React.Component<IProps, IStates> {
    state = {
        detail: undefined, 
        paramsHistory: undefined,
        formParams: undefined,
        productType: this.props.match.params.productType,
        refesh: this.refeshCotation
    }

    render(){
        return(
            <CotationCtx.Provider value={this.state}>
                {this.props.children}
            </CotationCtx.Provider>
        )
    }
    
    componentWillMount(){
        this.refeshCotation()
    }

    @autobind
    private refeshCotation(){
        const {fetch, fetchHistory, match, promisesWithProgress, toastError} = this.props
        promisesWithProgress(
            fetch(match.params.productType, match.params.cotationId)
                .then(res => this.setState({formParams: omit(res, ['cotation']), detail: res.cotation}))
                .catch(err => toastError(err.msg)),
            fetchHistory(match.params.productType, match.params.cotationId)
                .then(res => this.setState({paramsHistory: res}))
                .catch(err => toastError(err.msg)),
        )
    }

}

const dispatch2props = dispatch => ({
    fetch: (productType: string, id: string) => dispatch(getCotation(productType, id)),
    fetchHistory: (productType: string, id: string) => dispatch(getCotationHistory(productType, id)),
});

export default compose(
  withRouter,
  withGlobalProgress,
  withToast,
  connect(undefined, dispatch2props),
)(CotationProvider)


// WEBPACK FOOTER //
// ./src/page/Consumer/Cotation/CotationProvider.tsx